import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_ADVSEARCH_PARAM, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, getModVisiblity, linksUrl, SALE_PUR_ENTRY_TYPE } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faFileInvoice,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal, formatDate } from "../../Utility/utility"

import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetChallanReportData, resetDetailParams, setChallanReportDetail, setDetailParams, setNewEntryMode } from "../../state/saleEntrySlice"
import { resetPayVoutDetail } from "../../state/paymentEntrySlice"
import { resetRecVouDetail } from "../../state/receiveEntrySlice"
import { resetReportDetail, setInvoiceDetail } from "../../state/invoiceSlice"
import { isWithinInterval } from "date-fns"
import { is } from "date-fns/locale"
import { useEInvoiceHandlers } from "./eInvoiceService.js"
import { useModalToast } from "../../components/modalToast/ModalToastContext.jsx"


const SaleEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  const { user, token } = useSelector((state) => state.auth)
  const [itemToDelete, setItemToDelete] = useState("")
  const [tradeOf, setTradeOf] = useState()
  const [entryLabel, setEntryLabel] = useState("")
  const { typeid } = useParams();
  const [selReportPrint, setSelReportPrint] = useState("")
  const [isWithoutTakaEntry, setIsWithoutTakaEntry] = useState(false)
  const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
  const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
  const [data, setData] = useState([])
  const { show } = useModalToast();

  const { GenerateEinvoiceBill, GenerateEwaybill } = useEInvoiceHandlers

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)

    const params = [SALE_PUR_ENTRY_TYPE.GrayCloth, SALE_PUR_ENTRY_TYPE.Yarn, SALE_PUR_ENTRY_TYPE.Millgin, SALE_PUR_ENTRY_TYPE.General]
    if (!params.includes(String(typeid)))
      navigate(linksUrl.dashboard.tradingDashboard)

    disapatch(resetDetailParams())

    if (typeid && typeid != "") {
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_typeid = typeid.toLowerCase()
      if (t_typeid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
        t_tradeof = 'C'
        t_entryLabel = "Gray Cloth Sale"
      }
      else if (t_typeid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
        t_tradeof = 'Y'
        t_entryLabel = "Yarn Sale"
      }
      else if (t_typeid == SALE_PUR_ENTRY_TYPE.Millgin.toLowerCase()) {
        t_tradeof = 'M'
        t_entryLabel = "Millgin Sale"
      }
      else if (t_typeid == SALE_PUR_ENTRY_TYPE.General.toLowerCase()) {
        t_tradeof = 'G'
        t_entryLabel = "General Sale"
      }
      setTradeOf(t_tradeof)
      setEntryLabel(t_entryLabel)
      funFilterData(t_tradeof, null, null, null, null, null, null, null, null);
      setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: 'S', TradeOf: t_tradeof })
    }
  }, [typeid])

  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()

  const {
    isError,
    isPending,
    data: salesData = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.transaction.SaleEntry.fetch,
    queryKey: "Sales Data List",

  })
  const funFilterData = (trade, itemcode, pacid, brid, fromdate, todate, status, fduedate, tduedate) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        tradeof: String(trade),
        item_code: itemcode,
        pac_id: pacid,
        br_id: brid,
        from_date: fromdate,
        to_date: todate,
        status: status,
        fdue_date: fduedate,
        tdue_date: tduedate
      }
    })

  }
  useEffect(() => {
    setData(salesData)
  }, [salesData])
  const [isManualEntry, setIsManualEntry] = useState(false)
  const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
    url: apiRoute.modeSetting.getModSetting,
    queryKey: "fetchModSetting",
    inputData: {
      mod_name: ENUM_MOD_NAME.GraySaleMulti
    }
  })

  const onSuccessDetail = (data) => {
    let obj = []
    if (data && data?.itemData && data?.itemData.length > 0) {
      if (data?.itemDetail && data?.itemDetail.length > 0) {

        obj = {
          token: token,
          compcode: compCode.join(","),
          itemcode: data?.itemDetail[0].item_code,
          acid: data?.itemData[0].party_id,
          chalno: data?.itemData[0].chal_no,
          billno: data?.itemData[0].bill_no,
          action: "UPDATEDATA",
          ismanualentry: isManualEntry,
          billtype: 'S',
          tradeof: tradeOf,
          dbuser: GetLoginCredentialDb(user, yearId)
        }


      }
    }
    if (obj && Object.keys(obj).length > 0) {

      disapatch(resetPayVoutDetail())
      disapatch(resetRecVouDetail())
      disapatch(resetReportDetail())
      disapatch(resetChallanReportData())
      disapatch(setChallanReportDetail(obj))
      //window.open(linksUrl.report.invoice.rptInvoice, '_blank');
      onOpenReportModel()
    }
    else {
      if (!toast.isActive('toast_rptnodata')) {
        toast.error("No Data found", {
          "position": "top-center",
          toastId: "toast_rptnodata"
        })
      }
    }

  }
  const { isPending: isLoadingDetail, isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
    url: apiRoute.transaction.SaleEntry.fetchEntryDetail,
    queryKey: "InUpGrayStocEntryDetail",
    onSuccessTasks: onSuccessDetail
  })

  useEffect(() => {
    if (modSetting && modSetting.length > 0 && tradeOf == 'C') {
      let val = getModValue(ENUM_MOD_PARAMETER.saleEntry.TakaEntryMode, modSetting)

      if (val != "") {
        if (val.toLowerCase() == "stock") {
          setIsManualEntry(false)
        }
        else if (val.toLowerCase() == "manual") {
          console.log(val.toLowerCase())
          setIsManualEntry(true)
        }
      }
    }
  }, [modSetting, tradeOf])


  const onSuccessDelete = (data) => {
    setItemToDelete("")
    toast.success("deleted successfully", {
      position: "top-center"
    })
    funFilterData(tradeOf, null, null, null, null, null, null, null, null);
  }
  const fnisWithoutTaka = () => {
    if (!isWithoutTakaEntry && isManualEntry)
      return true
    else
      return false
  }
  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.transaction.SaleEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "invoice_amount",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "party_name",
    "Invoice_Det",
    "invoice_no",
    "invoice_amount",
    "invoice_date",
    "due_date",
    "account_name",
    "status"

  ]

  const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
    },
    {
      name: "Items",
      uid: "Invoice_Det",
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
    },
    {
      name: "BILL DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date
    },
    {
      name: "DUE DATE",
      uid: "due_date",
      type: COLUMN_TYPE.date
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
    },
    {
      name: "STATUS",
      uid: "status",
    },
  ]

  const ADVFILTER_VISIBLE_FIELD = [
    // ...Object.values(ENUM_ADVSEARCH_PARAM)
    ENUM_ADVSEARCH_PARAM.Status,
    ENUM_ADVSEARCH_PARAM.Party,
    ENUM_ADVSEARCH_PARAM.Broker,
    ENUM_ADVSEARCH_PARAM.Item,
    ENUM_ADVSEARCH_PARAM.VouFromDate,
    ENUM_ADVSEARCH_PARAM.VouToDate,
    ENUM_ADVSEARCH_PARAM.DueFromDate,
    ENUM_ADVSEARCH_PARAM.DueToDate,
    //  ENUM_ADVSEARCH_PARAM.VouNo,

  ]
  const handleFilterChange = (newFilters) => {
    console.log('Received filters in parent:', newFilters);
    
    setSelAdvanceFilter(newFilters)


   

    funFilterData(tradeOf,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Item) ? newFilters[ENUM_ADVSEARCH_PARAM.Item] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Party) ? newFilters[ENUM_ADVSEARCH_PARAM.Party] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Broker) ? newFilters[ENUM_ADVSEARCH_PARAM.Broker] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Status) ? newFilters[ENUM_ADVSEARCH_PARAM.Status] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueFromDate] : null,
      newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.DueToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.DueToDate] : null,


    )

  };


  let downloadDataFooter = {
    party_name: "",
    Invoice_Det: "",
    invoice_no: "",
    invoice_amount: "Total: " + totalAmt,
    invoice_date: "",
    due_date: "",
    account_name: "",
    status: ""
  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "PARTY NAME",
      uid: "party_name",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Items",
      uid: "Invoice_Det",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.multiline
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "BILL DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "DUE DATE",
      uid: "due_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "STATUS",
      uid: "status",
      align: COLUMN_ALIGN_TYPE.center,
    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {
      
      FndeleteNote({
        data: {
          transaction_id: itemToDelete.transaction_id,
          comp_code: itemToDelete.comp_code,
          chalno: itemToDelete.chal_no,
          manual_entry: isManualEntry,
          trade_of: tradeOf
        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        let obj = {
          comp_code: row.compcode,
          transaction_id: row.TransactionId,
          bill_type: 'S'

        }
        disapatch(setDetailParams(obj))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.transaction.SalesEntry + typeid + "/create-entry")
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.compcode, trn_no: row.Trn_No, chal_no: row.invoice_no })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#FFFFF" icon={faFileInvoice} />,
      onClick: (row) => {
        if (row.ewbill_no == '') {
          const confirmAction = window.confirm("Are you sure you want to generate the E-Way Bill?");
          if (confirmAction) {
            GenerateEwaybill({ CompCode: row.compcode, billtype: 'S', transactionid: row.TransactionId })
          }
        }
        else {
          show(<div>
            <div className="bg-blue-600 p-2 font-semibold  tracking-widest text-white uppercase text-sm">E-Way BILL DETAILS</div>
            <table className="w-full text-left border border-gray-300 rounded-lg overflow-hidden shadow-sm text-sm">
              <tbody>
                <tr className="border-b">
                  <td className="bg-gray-100 p-3 font-semibold text-gray-700 ">
                    E-WAY BILL NO:
                  </td>
                  <td className="p-3 text-gray-800 font-medium">
                    {row.ewbill_no}
                  </td>
                </tr>
                <tr>
                  <td className="bg-gray-100 p-3 font-semibold text-gray-700">
                    E-WAY BILL DATE:
                  </td>
                  <td className="p-3 text-gray-800 font-medium">
                    {formatDate(row.ewbill_date)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>)
        }
      },
      label: "E-Bill",
      color: "bg-green-500",
      type: ROW_ACTION_BTN_TYPE.button,
    },
    {
      icon: <FontAwesomeIcon color="#FFFFF" icon={faFileInvoice} />,
      onClick: (row) => {
        if (row.einv_irn == "" && row.einv_ackno == "") {
          const confirmAction = window.confirm("Are you sure you want to generate the E-Invoice?");
          if (confirmAction) {
            GenerateEinvoiceBill({ CompCode: row.compcode, billtype: 'S', transactionid: row.TransactionId })
          }
        }
        else
          show(<div>
            <div className="bg-blue-600 p-2 font-semibold  tracking-widest text-white text-sm">E INVOICE DETAILS</div>
            <table className="w-full text-left border border-gray-300 rounded-lg overflow-hidden shadow-sm text-sm">
              <tbody>
                <tr className="border-b">
                  <td className="bg-gray-100 p-3 font-semibold text-gray-700 w-1/3">
                    IRN NO:
                  </td>
                  <td className="p-3 text-gray-800 font-medium">
                    {row.einv_irn}
                  </td>
                </tr>

                <tr className="border-b">
                  <td className="bg-gray-100 p-3 font-semibold text-gray-700">
                    ACK NO:
                  </td>
                  <td className="p-3 text-gray-800 font-medium">
                    {row.einv_ackno}
                  </td>
                </tr>

                <tr>
                  <td className="bg-gray-100 p-3 font-semibold text-gray-700">
                    ACK DATE:
                  </td>
                  <td className="p-3 text-gray-800 font-medium">
                    {formatDate(row.einv_ackdate)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>)
      },
      label: "E-Invoice",
      color: "bg-red-500",
      type: ROW_ACTION_BTN_TYPE.button,
    },
    {
      icon: <FontAwesomeIcon color="#0a4da6" icon={faFileInvoice} />,
      onClick: (row) => {
        setSelReportPrint(enum_Report_Type.SALESINVOICE)
        let obj = {
          token: token,
          comp_code: row.compcode,
          acid: null,
          billno: row.invoice_no,
          billtype: "S",
          db_user: GetLoginCredentialDb(user, yearId)
        }

        disapatch(resetPayVoutDetail())
        disapatch(resetRecVouDetail())
        disapatch(resetReportDetail())
        disapatch(resetChallanReportData())
        disapatch(setInvoiceDetail(obj))
        onOpenReportModel()
      },
      label: "Bill",
      //tip:"Bill",
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: tradeOf == 'C' ? <FontAwesomeIcon color="#f18223" icon={faReceipt} /> : "",
      onClick: (row) => {
        if (tradeOf == 'C') {

          if (!getModVisiblity(ENUM_MOD_PARAMETER.saleEntry.TakaGridPcsNo, modSetting))
            setSelReportPrint(enum_Report_Type.GrayChallanWithoutTaka)
          else
            setSelReportPrint(enum_Report_Type.GrayChallan)
          // const bunches = []
          //const BUNCH_SIZE = 12
          funGetDetail({
            data: {
              compcode: row.compcode,
              transactionid: row.TransactionId,
              billtype: 'S',
            }
          })
        }

      },
      label: tradeOf == 'C' ? "Challan" : "",
      //tip:tradeOf == 'C' ? "Challan" : "",
      type: ROW_ACTION_BTN_TYPE.link,
    }

  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.transaction.SalesEntry + typeid + "/create-entry")
  }

  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="xl"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-row gap-1">
                  {selReportPrint == enum_Report_Type.GrayChallan || selReportPrint == enum_Report_Type.GrayChallanWithoutTaka ? "Challan Print" : "Bill Print"}
                </ModalHeader>
                <ModalBody className="overflow-auto ">
                  <div className="flex flex-col">
                    <ReportViewer props_ReportType={selReportPrint} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }

  return (
    <div>
      {reportModel()}
      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName={entryLabel}
        info={[]}
        breadcrumbs={["Sales", entryLabel]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="graySaleChallan-List"
          id="TransactionId"
          advanceFilterParam={selAdvanceFilter}
          advFilterPageApiParam={pageApiAdvFilter}
          advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
          onFilterChange={handleFilterChange}
        ></NextUITable>

      </MainContainer>

    </div>
  )
}
export default SaleEntryMaster
